import './XYChartCrosshair.css';
export var crosshair = '_1bbe5uo0-3-8-0';